enum ActivityListType {
  INCOMPLETE_ACTIVITIES = "incompleteActivities",
  COMPLETED_ACTIVITIES = "completedActivities",
}

export default ActivityListType;
